@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_365_472_470)
public val Res.plurals.answers_over_demand: PluralStringResource by lazy {
      PluralStringResource("plurals:answers_over_demand", "answers_over_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10, 294),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10, 430),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 151),
      ))
    }

@delegate:ResourceContentHash(-1_837_161_075)
public val Res.plurals.clock_review_flag_clock_drift_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:clock_review_flag_clock_drift_minutes", "clock_review_flag_clock_drift_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305, 388),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441, 640),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 162, 165),
      ))
    }

@delegate:ResourceContentHash(-468_429_279)
public val Res.plurals.comparison_days_compared: PluralStringResource by lazy {
      PluralStringResource("plurals:comparison_days_compared", "comparison_days_compared", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 694, 199),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1082, 271),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328, 116),
      ))
    }

@delegate:ResourceContentHash(-1_136_235_920)
public val Res.plurals.copy_day_day_shifts: PluralStringResource by lazy {
      PluralStringResource("plurals:copy_day_day_shifts", "copy_day_day_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 894, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1354, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 445, 71),
      ))
    }

@delegate:ResourceContentHash(861_368_757)
public val Res.plurals.copy_day_day_without: PluralStringResource by lazy {
      PluralStringResource("plurals:copy_day_day_without", "copy_day_day_without", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1009, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1485, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 517, 108),
      ))
    }

@delegate:ResourceContentHash(341_353_024)
public val Res.plurals.copy_day_picked: PluralStringResource by lazy {
      PluralStringResource("plurals:copy_day_picked", "copy_day_picked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1141, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1665, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 626, 79),
      ))
    }

@delegate:ResourceContentHash(-1_136_235_920)
public val Res.plurals.copy_day_source_shifts: PluralStringResource by lazy {
      PluralStringResource("plurals:copy_day_source_shifts", "copy_day_source_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1288, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1864, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 706, 74),
      ))
    }

@delegate:ResourceContentHash(256_040_314)
public val Res.plurals.copy_tool_copy_days: PluralStringResource by lazy {
      PluralStringResource("plurals:copy_tool_copy_days", "copy_tool_copy_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1406, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 1998, 234),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 781, 83),
      ))
    }

@delegate:ResourceContentHash(-1_136_235_920)
public val Res.plurals.daily_hours_shifts: PluralStringResource by lazy {
      PluralStringResource("plurals:daily_hours_shifts", "daily_hours_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1557, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 2233, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 865, 70),
      ))
    }

@delegate:ResourceContentHash(-2_125_775_820)
public val Res.plurals.dashboard_unread_messages: PluralStringResource by lazy {
      PluralStringResource("plurals:dashboard_unread_messages", "dashboard_unread_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1671, 232),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 2363, 348),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 936, 101),
      ))
    }

@delegate:ResourceContentHash(-1_082_267_453)
public val Res.plurals.duration_days: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_days", "duration_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 1904, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 2712, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1038, 57),
      ))
    }

@delegate:ResourceContentHash(-574_943_596)
public val Res.plurals.duration_hours_part: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_hours_part", "duration_hours_part", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2001, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 2829, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1096, 55),
      ))
    }

@delegate:ResourceContentHash(-17_012_799)
public val Res.plurals.duration_minutes_part: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_minutes_part", "duration_minutes_part", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2116, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 2972, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1152, 65),
      ))
    }

@delegate:ResourceContentHash(-637_504_955)
public val Res.plurals.duration_months: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_months", "duration_months", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2233, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3133, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1218, 67),
      ))
    }

@delegate:ResourceContentHash(-1_841_118_567)
public val Res.plurals.duration_weeks: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_weeks", "duration_weeks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2360, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3280, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1286, 62),
      ))
    }

@delegate:ResourceContentHash(1_823_133_964)
public val Res.plurals.duration_years: PluralStringResource by lazy {
      PluralStringResource("plurals:duration_years", "duration_years", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2482, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3418, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1349, 62),
      ))
    }

@delegate:ResourceContentHash(690_333_534)
public val Res.plurals.first_steps_team: PluralStringResource by lazy {
      PluralStringResource("plurals:first_steps_team", "first_steps_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2576, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3540, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1412, 100),
      ))
    }

@delegate:ResourceContentHash(-1_727_442_851)
public val Res.plurals.interview_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:interview_minutes", "interview_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2736, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3764, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1513, 69),
      ))
    }

@delegate:ResourceContentHash(527_340_276)
public val Res.plurals.missing_pay_title: PluralStringResource by lazy {
      PluralStringResource("plurals:missing_pay_title", "missing_pay_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 2849, 416),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 3921, 640),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1583, 189),
      ))
    }

@delegate:ResourceContentHash(-1_727_442_851)
public val Res.plurals.my_break_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:my_break_minutes", "my_break_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 3266, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 4562, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1773, 68),
      ))
    }

@delegate:ResourceContentHash(-48_942_321)
public val Res.plurals.my_breaks_total: PluralStringResource by lazy {
      PluralStringResource("plurals:my_breaks_total", "my_breaks_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 3378, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 4718, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1842, 87),
      ))
    }

@delegate:ResourceContentHash(-84_762_705)
public val Res.plurals.paywall_seats_tier: PluralStringResource by lazy {
      PluralStringResource("plurals:paywall_seats_tier", "paywall_seats_tier", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 3549, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 4937, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1930, 86),
      ))
    }

@delegate:ResourceContentHash(-1_970_953_780)
public val Res.plurals.paywall_team_size: PluralStringResource by lazy {
      PluralStringResource("plurals:paywall_team_size", "paywall_team_size", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 3679, 224),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 5091, 352),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2017, 117),
      ))
    }

@delegate:ResourceContentHash(543_596_264)
public val Res.plurals.plan_people_count: PluralStringResource by lazy {
      PluralStringResource("plurals:plan_people_count", "plan_people_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 3904, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 5444, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2135, 69),
      ))
    }

@delegate:ResourceContentHash(-220_362_769)
public val Res.plurals.plan_up_to_people: PluralStringResource by lazy {
      PluralStringResource("plurals:plan_up_to_people", "plan_up_to_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 4017, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 5573, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2205, 85),
      ))
    }

@delegate:ResourceContentHash(-335_393_064)
public val Res.plurals.roster_import_apply: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_import_apply", "roster_import_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 4146, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 5726, 254),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2291, 87),
      ))
    }

@delegate:ResourceContentHash(-1_852_325_508)
public val Res.plurals.roster_import_cells: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_import_cells", "roster_import_cells", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 4309, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 5981, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2379, 67),
      ))
    }

@delegate:ResourceContentHash(1_574_282_145)
public val Res.plurals.roster_import_codes_undecided: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_import_codes_undecided", "roster_import_codes_undecided", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 4440, 580),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 6144, 824),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2447, 245),
      ))
    }

@delegate:ResourceContentHash(1_372_859_094)
public val Res.plurals.roster_open_count: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_open_count", "roster_open_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5021, 144),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 6969, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2693, 81),
      ))
    }

@delegate:ResourceContentHash(-1_055_590_543)
public val Res.plurals.roster_overview_more: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_overview_more", "roster_overview_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5166, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 7178, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2775, 96),
      ))
    }

@delegate:ResourceContentHash(-971_665_893)
public val Res.plurals.roster_unfilled_count: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_unfilled_count", "roster_unfilled_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5338, 188),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 7358, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2872, 97),
      ))
    }

@delegate:ResourceContentHash(-885_718_872)
public val Res.plurals.roster_unpublished_count: PluralStringResource by lazy {
      PluralStringResource("plurals:roster_unpublished_count", "roster_unpublished_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5527, 235),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 7603, 347),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2970, 140),
      ))
    }

@delegate:ResourceContentHash(-550_104_736)
public val Res.plurals.schedule_available_count: PluralStringResource by lazy {
      PluralStringResource("plurals:schedule_available_count", "schedule_available_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5763, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 7951, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3111, 84),
      ))
    }

@delegate:ResourceContentHash(-618_820_647)
public val Res.plurals.skeleton_day_template_usage: PluralStringResource by lazy {
      PluralStringResource("plurals:skeleton_day_template_usage", "skeleton_day_template_usage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 5903, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 8127, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3196, 87),
      ))
    }

@delegate:ResourceContentHash(-246_064_255)
public val Res.plurals.staff_import_apply: PluralStringResource by lazy {
      PluralStringResource("plurals:staff_import_apply", "staff_import_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 6054, 161),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 8298, 269),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3284, 86),
      ))
    }

@delegate:ResourceContentHash(-225_651_040)
public val Res.plurals.staffing_too_few_days: PluralStringResource by lazy {
      PluralStringResource("plurals:staffing_too_few_days", "staffing_too_few_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 6216, 204),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 8568, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3371, 113),
      ))
    }

@delegate:ResourceContentHash(-840_850_542)
public val Res.plurals.staffing_too_many_days: PluralStringResource by lazy {
      PluralStringResource("plurals:staffing_too_many_days", "staffing_too_many_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 6421, 205),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 8837, 285),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3485, 114),
      ))
    }

@delegate:ResourceContentHash(310_569_716)
public val Res.plurals.start_path_templates_count: PluralStringResource by lazy {
      PluralStringResource("plurals:start_path_templates_count", "start_path_templates_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 6627, 169),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 9123, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3600, 102),
      ))
    }

@delegate:ResourceContentHash(544_599_251)
public val Res.plurals.todo_availability_answers: PluralStringResource by lazy {
      PluralStringResource("plurals:todo_availability_answers", "todo_availability_answers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 6797, 392),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 9341, 556),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3703, 205),
      ))
    }

@delegate:ResourceContentHash(-1_456_309_978)
public val Res.plurals.todo_remind: PluralStringResource by lazy {
      PluralStringResource("plurals:todo_remind", "todo_remind", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7190, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 9898, 226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3909, 79),
      ))
    }

@delegate:ResourceContentHash(1_700_385_309)
public val Res.plurals.todo_starts_in_hours: PluralStringResource by lazy {
      PluralStringResource("plurals:todo_starts_in_hours", "todo_starts_in_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7357, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10125, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3989, 76),
      ))
    }

@delegate:ResourceContentHash(-76_996_991)
public val Res.plurals.todo_starts_in_minutes: PluralStringResource by lazy {
      PluralStringResource("plurals:todo_starts_in_minutes", "todo_starts_in_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7493, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10333, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4066, 82),
      ))
    }

@delegate:ResourceContentHash(-928_599_953)
public val Res.plurals.tracker_unfilled: PluralStringResource by lazy {
      PluralStringResource("plurals:tracker_unfilled", "tracker_unfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 7627, 147),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10547, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4149, 76),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("answers_over_demand", Res.plurals.answers_over_demand)
  map.put("clock_review_flag_clock_drift_minutes", Res.plurals.clock_review_flag_clock_drift_minutes)
  map.put("comparison_days_compared", Res.plurals.comparison_days_compared)
  map.put("copy_day_day_shifts", Res.plurals.copy_day_day_shifts)
  map.put("copy_day_day_without", Res.plurals.copy_day_day_without)
  map.put("copy_day_picked", Res.plurals.copy_day_picked)
  map.put("copy_day_source_shifts", Res.plurals.copy_day_source_shifts)
  map.put("copy_tool_copy_days", Res.plurals.copy_tool_copy_days)
  map.put("daily_hours_shifts", Res.plurals.daily_hours_shifts)
  map.put("dashboard_unread_messages", Res.plurals.dashboard_unread_messages)
  map.put("duration_days", Res.plurals.duration_days)
  map.put("duration_hours_part", Res.plurals.duration_hours_part)
  map.put("duration_minutes_part", Res.plurals.duration_minutes_part)
  map.put("duration_months", Res.plurals.duration_months)
  map.put("duration_weeks", Res.plurals.duration_weeks)
  map.put("duration_years", Res.plurals.duration_years)
  map.put("first_steps_team", Res.plurals.first_steps_team)
  map.put("interview_minutes", Res.plurals.interview_minutes)
  map.put("missing_pay_title", Res.plurals.missing_pay_title)
  map.put("my_break_minutes", Res.plurals.my_break_minutes)
  map.put("my_breaks_total", Res.plurals.my_breaks_total)
  map.put("paywall_seats_tier", Res.plurals.paywall_seats_tier)
  map.put("paywall_team_size", Res.plurals.paywall_team_size)
  map.put("plan_people_count", Res.plurals.plan_people_count)
  map.put("plan_up_to_people", Res.plurals.plan_up_to_people)
  map.put("roster_import_apply", Res.plurals.roster_import_apply)
  map.put("roster_import_cells", Res.plurals.roster_import_cells)
  map.put("roster_import_codes_undecided", Res.plurals.roster_import_codes_undecided)
  map.put("roster_open_count", Res.plurals.roster_open_count)
  map.put("roster_overview_more", Res.plurals.roster_overview_more)
  map.put("roster_unfilled_count", Res.plurals.roster_unfilled_count)
  map.put("roster_unpublished_count", Res.plurals.roster_unpublished_count)
  map.put("schedule_available_count", Res.plurals.schedule_available_count)
  map.put("skeleton_day_template_usage", Res.plurals.skeleton_day_template_usage)
  map.put("staff_import_apply", Res.plurals.staff_import_apply)
  map.put("staffing_too_few_days", Res.plurals.staffing_too_few_days)
  map.put("staffing_too_many_days", Res.plurals.staffing_too_many_days)
  map.put("start_path_templates_count", Res.plurals.start_path_templates_count)
  map.put("todo_availability_answers", Res.plurals.todo_availability_answers)
  map.put("todo_remind", Res.plurals.todo_remind)
  map.put("todo_starts_in_hours", Res.plurals.todo_starts_in_hours)
  map.put("todo_starts_in_minutes", Res.plurals.todo_starts_in_minutes)
  map.put("tracker_unfilled", Res.plurals.tracker_unfilled)
}
